import React, { useState } from 'react';
import { LIBRARY, C, libFind } from './constants.jsx';

export default function LibrarySidebar({ comps, selId, onAdd, onSelect, onDelete }) {
  const [search, setSearch] = useState('');
  const [openGroups, setOpenGroups] = useState({ Layout: true, 'Data Display': true, Forms: true, Actions: false, Content: false });

  const toggleGroup = (g) => setOpenGroups((p) => ({ ...p, [g]: !p[g] }));

  const filtered = LIBRARY.map((grp) => ({
    ...grp,
    items: grp.items.filter(
      (i) => !search || i.label.toLowerCase().includes(search.toLowerCase()) || i.desc.toLowerCase().includes(search.toLowerCase())
    ),
  })).filter((grp) => grp.items.length > 0);

  return (
    <div style={{
      width: 224, background: C.surface, borderRight: `1px solid ${C.border}`,
      display: 'flex', flexDirection: 'column', flexShrink: 0, overflow: 'hidden',
    }}>
      {/* Header */}
      <div style={{
        padding: '11px 13px', borderBottom: `1px solid ${C.border}`,
        display: 'flex', alignItems: 'center', gap: 8, flexShrink: 0,
      }}>
        <div style={{
          width: 28, height: 28, borderRadius: 7,
          background: 'linear-gradient(135deg,#2563EB,#7C3AED)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          color: '#fff', fontSize: 13, fontWeight: 700, flexShrink: 0,
        }}>S</div>
        <div>
          <div style={{ fontSize: 13, fontWeight: 700 }}>Screen Builder</div>
          <div style={{ fontSize: 11, color: C.muted }}>v2 — Full Config</div>
        </div>
      </div>

      {/* Search */}
      <div style={{ padding: '8px 10px', borderBottom: `1px solid ${C.border}`, flexShrink: 0 }}>
        <input
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          placeholder="Search components…"
          style={{
            width: '100%', padding: '6px 9px',
            border: `1px solid ${C.border}`, borderRadius: 6,
            fontSize: 12, outline: 'none', background: C.bg,
            color: C.text, fontFamily: 'inherit', boxSizing: 'border-box',
          }}
        />
      </div>

      {/* Library */}
      <div style={{ flex: 1, overflowY: 'auto' }}>
        {filtered.map((grp) => (
          <div key={grp.group}>
            <div
              onClick={() => toggleGroup(grp.group)}
              style={{
                padding: '8px 13px 4px', fontSize: 10, fontWeight: 700,
                color: C.sub, letterSpacing: '.07em', textTransform: 'uppercase',
                cursor: 'pointer', display: 'flex', justifyContent: 'space-between',
                alignItems: 'center', userSelect: 'none',
              }}
            >
              {grp.group}
              <span style={{ fontSize: 9, color: C.muted }}>{openGroups[grp.group] ? '▲' : '▼'}</span>
            </div>
            {openGroups[grp.group] && grp.items.map((item) => (
              <div
                key={item.type}
                onClick={() => onAdd(item.type)}
                style={{ padding: '7px 11px', cursor: 'pointer', display: 'flex', gap: 9, alignItems: 'flex-start' }}
                onMouseEnter={(e) => (e.currentTarget.style.background = C.bg)}
                onMouseLeave={(e) => (e.currentTarget.style.background = 'transparent')}
              >
                <div style={{
                  width: 27, height: 27, borderRadius: 6,
                  background: C.accentLt, display: 'flex', alignItems: 'center',
                  justifyContent: 'center', fontSize: 12, color: C.accent, flexShrink: 0, fontWeight: 700,
                }}>
                  {item.icon}
                </div>
                <div>
                  <div style={{ fontSize: 12, fontWeight: 500, color: C.text }}>{item.label}</div>
                  <div style={{ fontSize: 11, color: C.muted, marginTop: 1, lineHeight: 1.3 }}>{item.desc}</div>
                </div>
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* Layers */}
      {comps.length > 0 && (
        <div style={{ borderTop: `1px solid ${C.border}`, maxHeight: 180, overflowY: 'auto', flexShrink: 0 }}>
          <div style={{
            padding: '7px 13px 4px', fontSize: 10, fontWeight: 700,
            color: C.sub, letterSpacing: '.07em', textTransform: 'uppercase',
          }}>
            Layers ({comps.length})
          </div>
          {[...comps].reverse().map((c) => {
            const lib = libFind(c.type);
            return (
              <div
                key={c.id}
                onClick={() => onSelect(c.id)}
                style={{
                  padding: '6px 13px', cursor: 'pointer', display: 'flex',
                  alignItems: 'center', gap: 7, fontSize: 12,
                  background: selId === c.id ? C.accentLt : 'transparent',
                  color: selId === c.id ? C.accent : C.text,
                  transition: 'background .1s',
                }}
                onMouseEnter={(e) => { if (selId !== c.id) e.currentTarget.style.background = C.bg; }}
                onMouseLeave={(e) => { if (selId !== c.id) e.currentTarget.style.background = 'transparent'; }}
              >
                <span style={{ fontSize: 11, flexShrink: 0 }}>{lib.icon}</span>
                <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                  {lib.label}
                </span>
                <button
                  onClick={(e) => { e.stopPropagation(); onDelete(c.id); }}
                  style={{ background: 'none', border: 'none', color: C.muted, cursor: 'pointer', fontSize: 13, padding: '0 4px', lineHeight: 1, flexShrink: 0 }}
                  onMouseEnter={(e) => (e.currentTarget.style.color = C.red)}
                  onMouseLeave={(e) => (e.currentTarget.style.color = C.muted)}
                >×</button>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
